import { T12 } from "./SalesSummaryPerProductGroup/T12"

export const AgentPerformanceByProductGroup = {
  "sections": [
    T12
  ]
}